import { TextMessageListCombinedProps } from './types';

const usePresenter = (props: TextMessageListCombinedProps): TextMessageListCombinedProps => {
  return props;
};

export default usePresenter;
